//综合查询

const tabelQuerytoB = () => import(/* webpackChunkName: "permissions" */ '../../views/comprehensiveQuery/tabelQuery'),
    tabelQuerytoC = () => import(/* webpackChunkName: "permissions" */ '../../views/comprehensiveQuery/tabelQuerytoC'), // 宽表查询
    tableQueryOperate = () => import(/* webpackChunkName: "permissions" */ '../../views/comprehensiveQuery/tableQueryOperate'), // 运营新增宽表
    exportFileManagement = () => import(/* webpackChunkName: "permissions" */ '../../views/comprehensiveQuery/exportFileManagement'); // 导出文件管理

export default [
    {
        path: '/comprehensiveQuery/tabelQuery',
        name: 'tabelQuery',

        meta: { title: 'tob宽表查询',selfFlg: 'wide_table', },
        selfFlg: 'wide_table',
        component: tabelQuerytoB
    },
    {
        path: '/comprehensiveQuery/tabelQuerytoC',
        name: 'tabelQuerytoC',

        meta: { title: 'toc宽表查询',selfFlg: 'wide_table_c', },
        component: tabelQuerytoC
    },
    {
        path: '/comprehensiveQuery/tableQueryOperate',
        name: 'tableQueryOperate',

        meta: { title: '运营新增宽表', selfFlg: 'run', },
        component: tableQueryOperate
    },
    {
        path: '/comprehensiveQuery/exportFileManagement',
        name: 'exportFileManagement',

        meta: { title: '导出文件管理',selfFlg: 'export_file', },
        component: exportFileManagement
    }
];
